import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LanguagePicker from "../../../components/misc/LanguagePicker";
import { scrollToFarmSection } from "./farmNavigationScroll";

export default function FarmNavigation() {
  const language = useSelector((state) => state.app.language);
  const sv = language === 0;
  const location = useLocation();
  const navigate = useNavigate();
  const onLandingPage = !location.pathname.startsWith("/farm/products/");
  const navigationRef = useRef(null);
  const [hidden, setHidden] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const goToSection = (section) => {
    if (onLandingPage) scrollToFarmSection(section);
    else navigate(`/${section}`);
  };

  useEffect(() => {
    let lastDirectionY = window.scrollY;
    let frame;
    let idleTimer;

    const update = () => {
      frame = undefined;
      const currentY = window.scrollY;
      const distance = currentY - lastDirectionY;
      const headerHeight = navigationRef.current?.offsetHeight || 80;

      setScrolled(currentY > 8);
      if (currentY <= headerHeight || distance < -8) {
        setHidden(false);
        lastDirectionY = currentY;
      } else if (distance > 8) {
        const hasFocus = navigationRef.current?.contains(document.activeElement);
        setHidden(!hasFocus);
        lastDirectionY = currentY;
      }

      window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(() => setHidden(false), 650);
    };

    const onScroll = () => {
      if (frame === undefined) frame = window.requestAnimationFrame(update);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (frame !== undefined) window.cancelAnimationFrame(frame);
      window.clearTimeout(idleTimer);
    };
  }, []);

  return (
    <div ref={navigationRef} className={`FarmNavigationShell${hidden ? " isHidden" : ""}${scrolled ? " isScrolled" : ""}`}>
      <header className="FarmStartNav FarmLandingContainer">
        {onLandingPage
          ? <a className="FarmStartWordmark" href="#farm-start" aria-label="VERT.farm — start">VERT<span>.farm</span></a>
          : <Link className="FarmStartWordmark" to="/farm" aria-label="VERT.farm — start">VERT<span>.farm</span></Link>}
        <nav aria-label={sv ? "Huvudnavigering" : "Main navigation"}>
          <button type="button" onClick={() => goToSection("farm/info")}>INFO</button>
          <button type="button" onClick={() => goToSection("farm/products")}>{sv ? "SORTIMENT" : "PRODUCTS"}</button>
          <button type="button" onClick={() => goToSection("farm/partners")}>{sv ? "ÅTERFÖRSÄLJARE" : "RETAILERS"}</button>
          <button type="button" onClick={() => goToSection("farm/contact")}>{sv ? "KONTAKTA OSS" : "CONTACT US"}</button>
        </nav>
        <LanguagePicker />
      </header>
    </div>
  );
}
